import React from "react";
import { Modal, Input, Form, Button } from "antd";
import { useTranslation } from "react-i18next";

import "@/assets/dynamicPhoto.less";

const DynamicPhotoWorkEmailModalRender = ({ visible, onCancel, codeVerifyError, email, handleResendCodeTimer, timeNumber, handleSubmit }) => {
  const { t } = useTranslation(["dynamicPhoto"]);
  const [form] = Form.useForm();

  const validateMessages = {
    required: "",
  };
  return (
    <Modal
      centered
      visible={visible}
      onCancel={onCancel}
      footer={null}
      width="500px"
      getContainer={document.querySelector(".Home")}
      className="emailCodeModal"
      maskClosable={false}
    >
      <h3>{t("Enter verification code")}</h3>
      <p>
        {t("Enter the verification code that we sent to", { email })}{" "}
        <Button onClick={handleResendCodeTimer} disabled={timeNumber ? true : false} className="resend-code" style={{ padding: 0 }} type="text">
          {timeNumber ? t("Resend after", { num: timeNumber }) : t("Resend")}
        </Button>
      </p>
      <Form form={form} validateMessages={validateMessages} onFinish={handleSubmit}>
        <Form.Item name="code" rules={[{ required: true }]}>
          <Input placeholder={t("Enter verification code")} />
        </Form.Item>
        <Form.Item shouldUpdate>
          {() => (
            <Button
              type="primary"
              size="large"
              htmlType="submit"
              disabled={!form.isFieldTouched("code") || !!form.getFieldsError().filter(({ errors }) => errors.length).length}
            >
              {t("common:Confirm")}
            </Button>
          )}
        </Form.Item>
      </Form>
      {codeVerifyError && <span className="error-tips">{t("The verification code is invalid. You can request a new one.")}</span>}
    </Modal>
  );
};

export default DynamicPhotoWorkEmailModalRender;
